/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "กำลังโหลด"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var thTH = Object.assign(TranslationProviderComponent, {
  translations
});

export { thTH as t };
//# sourceMappingURL=th-TH-C93Q997P.js.map
